import type { VideoVersion } from '@src/types.ts/story';

/**
 * PLAT-11911 — the clip Creator Studio holds differs in content from Dato's
 * head version. `NewVideoVersionListener` shows its newer-version modal.
 */
export const STALE_VIDEO_DETECTED_EVENT = 'stale-video-detected';

export function dispatchStaleVideoDetected(head: VideoVersion): void {
  window.dispatchEvent(
    new CustomEvent<VideoVersion>(STALE_VIDEO_DETECTED_EVENT, { detail: head }),
  );
}
